import {MissingTranslationHandler, MissingTranslationHandlerParams, TranslateCompiler, TranslateDefaultParser} from "@ngx-translate/core";
import {Inject, Injectable} from "@angular/core";
import {isEmpty} from "radash";
import {Miljø, MILJØ} from "felles-ng2/tjenester/Appkonfigurasjon";

/**
 * Sørger for å dekorere alle tekster som er markert for oversettelse, men hvor
 * nøkkel ikke er oversatt for enkel identifikasjon i skjermbilder.
 */
@Injectable()
export class ManglendeOversettelserHandler implements MissingTranslationHandler {

    constructor(@Inject(MILJØ) private readonly miljø: Miljø) {
    }

    handle(params: MissingTranslationHandlerParams) {
        let oversettelse = params.translateService.parser.interpolate(params.key, params.interpolateParams);
        if (this.miljø === Miljø.test) oversettelse = `[ MANGLER: '${oversettelse}' ]`;

        return oversettelse;
    }
}

/**
 * Sørger for at alle oversettelser blir "dekortert" med [] når vi er i Miljø.test
 * for å enklere å identifisere tekst som er oversatt.
 */
@Injectable()
export class OversettelsesCompiler implements TranslateCompiler {


    constructor(@Inject(MILJØ) private readonly miljø: Miljø) {
    }

    compile(value: string, lang: string): string | Function {
        if (this.ikkeSkalDekorereOversettelser()) return value;
        return `[${value}]`;
    }

    compileTranslations(translations: Record<string, string>, lang: string): any {
        if (this.ikkeSkalDekorereOversettelser()) return translations;
        if (isEmpty(translations)) return translations

        return Object.keys(translations).reduce((result, key) => {
            result[key] = `[${translations[key]}]`;
            return result;
        }, {} as Record<string, string>)
    }

    private ikkeSkalDekorereOversettelser() {
        return this.miljø !== Miljø.test;
    }

}

/**
 * Sørger for at vi kan skrive nøkler på formen "Hei, jeg er en nøkkel med {parameter}"
 * og bruke disse f.eks. i pipe for oversettelse.
 *
 * Uten vil standard oppførsel være at parameter må være omsluttet av {{}}, som {{etparameter}}, da klager Angular
 */
@Injectable()
export class EnkleKrøllParenteserForParametereParser extends TranslateDefaultParser {
    public templateMatcher: RegExp = /{\s?([^{}\s]*)\s?}/g;
}
